import * as tslib_1 from "tslib";
import getStore from '../data/store/store';
import getCalendarProcessingOptions from '../services/getCalendarProcessingOptions';
import initializeCalendarProcessingOptions from '../actions/initializeCalendarProcessingOptions';
/**
 * Util to get calendar processing options and initialize store if not present
 */
export default function initCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var calendarProcessingOptions, calendarOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    calendarProcessingOptions = getStore().calendarProcessingOptions;
                    if (!!calendarProcessingOptions) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCalendarProcessingOptions()];
                case 1:
                    calendarOptions = _a.sent();
                    initializeCalendarProcessingOptions(calendarOptions);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initCalendarProcessingOptions.js.map